import { Component, OnInit } from '@angular/core';
import { ConfigsService } from '../configs.service';

@Component({
  selector: 'app-rodape',
  templateUrl: './rodape.component.html',
  styleUrls: ['./rodape.component.css']
})
export class RodapeComponent implements OnInit {
  dataAtual:any = new Date();
  anoAtual = this.dataAtual.getFullYear();
  corTexto:string;
  constructor(private config:ConfigsService) {
    this.corTexto = this.config.corPadrao;
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/rodape/rodape.component.ts